module.exports = __webpack_public_path__ + "82b08817d1cd301ec24e8ddb87396c86.svg";